export const GAME_TITLE = 'Mahjong Handle'
export const GAME_URL = window.location.origin + '/'

export const WIN_MESSAGES = ['干得漂亮！', '猜中了！', '厉害！']
export const GAME_COPIED_MESSAGE = '结果已复制到剪贴板'
export const ABOUT_GAME_MESSAGE = '关于游戏'
export const NOT_ENOUGH_LETTERS_MESSAGE = '牌数不足'
export const KEYBOARD_SHORTCUT_REMINDER_MESSAGE = '（可输入 m、p、s、z 转换牌面）'
export const WORD_NOT_FOUND_MESSAGE = '手牌必须至少包含一个役'
export const INVALID_HAND_MESSAGE = '手牌不合法'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `正确手牌是 ${solution}`
export const ENTER_TEXT = '提交'
export const DELETE_TEXT = '删除'
export const STATISTICS_TITLE = '统计'
export const GUESS_DISTRIBUTION_TEXT = '猜测分布'
export const NEXT_HAND_TEXT = '下一局'
export const SHARE_TEXT = '分享'
export const TOTAL_TRIES_TEXT = '总场次'
export const SUCCESS_RATE_TEXT = '胜率'
export const AVERAGE_GUESSES_TEXT = '平均猜测'
export const CURRENT_STREAK_TEXT = '当前连胜'
export const BEST_STREAK_TEXT = '最佳连胜'
